import {EtsyListing} from '@coolcolduk/etsy';
import {MenuItem, TextField} from '@mui/material';
import {HookAccountToken} from '../../hook/useGetAllAccountToken';
import {useGetAllTemplateListings} from '../../hook/useGetAllTemplateListings';
import {HelpTutorialEnum} from '../../variables/helpTutorial';
import HelpButtonWrapper from '../helpButton/HelpButtonWrapper';

export interface EtsyListingTemplateSelectorProps {
  selectedAccount: HookAccountToken;
  selectedListing?: EtsyListing;
  setSelectedListing: (l?: EtsyListing) => void;
}

/**
 * dropdown with list of templates
 * @param _props
 * @returns
 */
export default function EtsyListingTemplateSelector({
  selectedAccount,
  selectedListing,
  setSelectedListing,
}: EtsyListingTemplateSelectorProps) {
  const templateListings = useGetAllTemplateListings(selectedAccount.id);

  return (
    <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.ETSY_CREATE_TEMPLATE}>
      <TextField
        id="template-select"
        value={selectedListing ? selectedListing.title : ''}
        label="Template"
        select
        onChange={(e) => setSelectedListing(templateListings.find((l) => l.title === e.target.value))}
        sx={{minWidth: '200px', width: '100%', mr: 5}}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {templateListings.map((l) => (
          <MenuItem key={l.title} value={l.title}>
            {l.title}
          </MenuItem>
        ))}
      </TextField>
    </HelpButtonWrapper>
  );
}
